import script from "./PaymentDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDashboard.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDashboard.vue?vue&type=style&index=0&id=29fd1e0e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29fd1e0e"]])

export default __exports__